import React from 'react';
import { css } from '@emotion/core';
import { inject, observer } from 'mobx-react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import { Popover } from 'antd';
import { ConnectAccount, Indication3 } from './styled';
import Input from '../../common/Input';
import { InfoLabel } from '../Screen3/styled';
import { colors } from '../../../constants';
import IconSvg from '../../common/IconSvg';

@inject('onboardingStore')
@observer
class NonApiConnection extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      // @todo onboarding delete this after we have more locations
      storeName: '',
      paypalName: '',
      nonApiToken: '',
    };
  }
  handleStoreNameChange = e => {
    const val = e.target.value;
    this.setState({ storeName: val });
  };

  handlePaypalNameChange = e => {
    const val = e.target.value;
    this.setState({ paypalName: val });
  };

  handleNonApiTokenChange = e => {
    const val = e.target.value;
    this.setState({ nonApiToken: val });
  };

  connectNonApi = () => {
    const { storeName, paypalName, nonApiToken } = this.state;
    const NonApiToken = nonApiToken;
    const { connectAccount } = this.props;
    if (storeName && paypalName && this.paypalIsEmail())
      connectAccount(storeName, paypalName, NonApiToken);
  };

  paypalIsEmail = () => {
    const { paypalName } = this.state;
    // eslint-disable-next-line no-useless-escape
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(paypalName.toLowerCase());
  };

  render() {
    const { error } = this.props;
    const { storeName, paypalName, nonApiToken } = this.state;
    return (
      <div
        css={css`
          width: 45%;
          order: 2;
          margin-top: 10px;
          padding-bottom: 35px;
        `}
      >
        <Indication3 />
        <div
          css={css`
            margin-top: 6px;
          `}
        >
          <InfoLabel
            css={css`
              width: 40%;
              display: inline-block;
            `}
          >
            <FormattedMessage id="onboarding.screen4.ebayUserId" />{' '}
            <span style={{ color: 'red' }}>*</span>
            <Popover
              content={
                <a
                  css={css`
                    cursor: pointer;
                  `}
                  href="https://www.ebay.com/myb/Summary"
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  Please provide the exact name of your store. If you are not sure, click here to
                  check before continuing.
                </a>
              }
              title=""
              trigger="hover"
              placement="bottom"
            >
              <a href="https://www.ebay.com/myb/Summary" rel="noopener noreferrer" target="_blank">
                <IconSvg
                  type="info"
                  css={css`
                    height: 20px;
                    margin-left: 4px;
                    cursor: pointer;
                  `}
                />
              </a>
            </Popover>
          </InfoLabel>
          <Input
            type="text"
            onChange={this.handleStoreNameChange}
            width="60%"
            defaultValue={storeName}
          />
        </div>
        <div
          css={css`
            margin-top: 6px;
          `}
        >
          <InfoLabel
            css={css`
              width: 40%;
              display: inline-block;
            `}
          >
            <FormattedMessage id="subscription.paypalAccount" />{' '}
            <span style={{ color: 'red' }}>*</span>
          </InfoLabel>
          <Input
            type="text"
            onChange={this.handlePaypalNameChange}
            width="60%"
            defaultValue={paypalName}
            style={{ borderColor: paypalName && !this.paypalIsEmail() ? 'red' : '' }}
          />
        </div>
        <div
          css={css`
            margin-top: 6px;
          `}
        >
          <InfoLabel
            css={css`
              width: 40%;
              display: inline-block;
            `}
          >
            <FormattedMessage id="subscription.nonApiToken" />
            <Popover
              content={
                <a
                  css={css`
                    cursor: pointer;
                  `}
                  href="https://signin.ebay.com/ws/eBayISAPI.dll?SignIn&runame=F-FILEEXL51P1EHH6L899Q9B969GE134DK-FileUpload"
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  (Optional input) If you are not sure where to get the token from, click here.
                </a>
              }
              title=""
              trigger="hover"
              placement="bottom"
            >
              <IconSvg
                type="info"
                css={css`
                  height: 20px;
                  margin-left: 4px;
                  cursor: pointer;
                `}
              />
            </Popover>
          </InfoLabel>
          <Input
            type="text"
            onChange={this.handleNonApiTokenChange}
            width="60%"
            defaultValue={nonApiToken}
            placeholder="optional"
          />
        </div>
        <h4
          css={css`
            position: absolute;
            color: ${colors.red};
            font-family: Heebo-Light;
            font-size: 14px;
          `}
        >
          {paypalName && !this.paypalIsEmail() && '* Invalid email address'}
        </h4>
        <h4
          css={css`
            color: ${colors.red};
            position: absolute;
          `}
        >
          {paypalName && this.paypalIsEmail() && error}
        </h4>
        <ConnectAccount clickHandler={this.connectNonApi} />
      </div>
    );
  }
}

NonApiConnection.propTypes = {
  connectAccount: PropTypes.func,
};

export default NonApiConnection;
